<template>
  <div>
    <div class="card card-default mb-4">
      <h4 class="card-header" :class="{ 'disabled': generatingInvoices.expired }">

        <i
          v-if="generatingInvoices.expired"
          class="fa fa-exclamation-triangle text-warning" />
          Invoice Id: {{ generatingInvoices.invoiceId }}
      </h4>
      <div class="card-body">
        <p
          class="alert alert-warning"
          v-if="generatingInvoices.expired">
          generatingInvoices has expired
        </p>
        <h5 class="mb-1">
          <span v-if="generatingInvoices.reference">
             <b>Quote Reference Number:</b> {{ generatingInvoices.reference}}
          </span>
          <em v-else>No data available</em>
        </h5>
        <h6>
          <span v-if="generatingInvoices.propertyAddress">
            <i class="fas fa-home fa-fw" /> <b>Property Address:</b> {{ generatingInvoices.propertyAddress }}
          </span>
         </h6>
        <label v-if="!generatingInvoices.expired && generatingInvoices.approved" class="label label-info label-header">Approved</label>
        <label v-if="!generatingInvoices.expired && generatingInvoices.approved" class="label label-success label-header">Under Progress</label>
        <br />
        <p class="mb-1">
          <i class="fas fa-clock fa-fw" /> <b>Created On:</b> {{ generatingInvoices.createdAt | date_time_format }}
        </p>
        <p class="mb-1">
          <i class="fas fa-dollar-sign fa-fw" /> <b>Estimated Quote Amount:</b> {{ generatingInvoices.fullCost | toDollarAmount }}
        </p>
      </div>
      <div class="card-footer">
        <button class="my-1 btn btn-success" @click="upload()"  v-if="!generatingInvoices.expired">
          <i class="fa fa-upload"></i> Preview
        </button>
      </div>
    </div>
  </div>
</template>


<script>
  import DownloadInput from '@/components/inputs/DownloadInput'
  export default {
    name: 'InvoiceCard',
    props: {
      object: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    components: {
      DownloadInput
    },
    computed: {
      generatingInvoices () {
        return {
          ...this.object
        }
      }
    },
    methods: {
      async upload () {
        // await this.$store.dispatch(UPLOAD_generatingInvoices, this.quote.uuid)
      },
      async del () {
        // await this.$store.dispatch(DELETE_TAX_generatingInvoices_REQUEST, this.quote.uuid)
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/cards/Invoice.vue